export default __webpack_public_path__ + "static/media/api.0960b989.svg";